import React from 'react';
import { Container, Typography, Accordion } from '@pwskills/rachnaui';
import Link from 'next/link';
import constants from '@/utils/faqs/faqs.constants';
import IFaq from '@/interfaces/faqs';
import { cleanHtml } from '@/utils/GlobalCommonFunctions';

const Faqs = () => {
  const renderLink = (faq: IFaq) => {
    if (faq.mail) {
      return (
        <Link href={`mailto:${faq.mail}`} className="text-linkBlue">
          {faq.mail}
        </Link>
      );
    }
    if (faq.url) {
      return (
        <Link href="/" target="_blank" className="text-linkBlue">
          {faq.url}
        </Link>
      );
    }
    if (faq.video) {
      return (
        <iframe
          src={`${faq.video}`}
          style={{ width: '100%', height: '255px', borderRadius: '10px' }}
          title={`faq-page-video-${faq._id}`}
          className="rounded-lg w-full mx-auto h-[255px]"
          loading="lazy"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      );
    }
    return null;
  };

  const handleOnClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    let currentElem = event?.target as HTMLButtonElement;
    if (currentElem && currentElem?.closest('.faq-dropdown')) return;
    currentElem = currentElem?.closest('.faq-container > div') as HTMLButtonElement;

    if (currentElem?.classList?.contains('bg-stroke-100')) {
      currentElem?.classList?.remove('bg-stroke-100', '[&>hr]:hidden', 'border-none');
    } else {
      currentElem?.classList?.add('bg-stroke-100', '[&>hr]:hidden', 'border-none');
    }
  };

  return (
    <Container className="my-8 regular:my-14">
      <Typography
        component="h1"
        variant="bold"
        className="text-center font-inter pb-9 regular:pb-14 !text-gray-850"
      >
        {constants.faqHeading}
      </Typography>
      <div className="flex flex-col space-y-2 regular:space-y-4">
        {constants.faqsData.map((faq) => (
          <button className="faq-container" key={faq._id} onClick={handleOnClick} type="button">
            <Accordion
              title={faq.question}
              titleClass="font-inter !font-semibold text-left text-gray-850"
              className="faq-dropdown"
            >
              <>
                <div
                  dangerouslySetInnerHTML={{ __html: cleanHtml(faq.answer) }}
                  className="!text-gray-650 text-left font-normal text-[1rem]"
                />
                {renderLink(faq)}
              </>
            </Accordion>
          </button>
        ))}
      </div>
    </Container>
  );
};

export default Faqs;

// {
//   /* <Typography component="body-regular" variant="regular" className="!text-gray-650 text-left">
//   {/* {
//                   faq.answer} */
// }
